import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchInput'

export default defineMessages({
  inputAriaLabel: {
    id: `${scope}.inputAriaLabel`,
    defaultMessage: 'Global search',
  },
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Search by ID, keyword, or ask a question',
  },
})
